import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastTone = 'success' | 'error' | 'info'

export interface ToastMessage {
  id: number
  title: string
  description?: string
  tone: ToastTone
}

let toastId = 0

export const useUiStore = defineStore('ui', () => {
  const commandPaletteOpen = ref(false)
  const toasts = ref<ToastMessage[]>([])

  function pushToast(message: Omit<ToastMessage, 'id'>) {
    const id = ++toastId
    toasts.value.push({ id, ...message })
    window.setTimeout(() => dismissToast(id), 4_500)
    return id
  }

  function dismissToast(id: number) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
  }

  return {
    commandPaletteOpen,
    toasts,
    pushToast,
    dismissToast,
  }
})
